import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";
import dayjs from "dayjs";

const styles = StyleSheet.create({
	tableContainer: {
		width: "100%",
		marginVertical: 10,
	},
	tableRow: {
		flexDirection: "row",
		borderBottomWidth: 1,
		borderBottomColor: "#bfbfbf",
		borderBottomStyle: "solid",
		alignItems: "stretch",
		minHeight: 20,
		// 2. Adicionamos as bordas laterais na LINHA, assim elas sempre existem
		borderLeftWidth: 1,
		borderLeftColor: "#bfbfbf",
		borderLeftStyle: "solid",
		borderRightWidth: 1,
		borderRightColor: "#bfbfbf",
		borderRightStyle: "solid",
	},
	headerRow: {
		backgroundColor: "#122149",
		borderTopWidth: 1,
		borderTopColor: "#bfbfbf",
		borderTopStyle: "solid",
		marginTop: 10,
	},
	oddRowBackground: {
		backgroundColor: "#edf1fa",
	},
	tableCellView: {
		padding: 2,
		borderRightWidth: 1,
		borderRightColor: "#d8d8d8",
		borderRightStyle: "solid",
		justifyContent: "center",
	},
	tableCellText: {
		fontSize: 8,
		textAlign: "left",
	},
	headerCellText: {
		fontSize: 10,
		fontWeight: "bold",
		textAlign: "left",
		color: "#fff",
	},
	lastCell: {
		borderRightWidth: 0,
	},
	colAlert: { width: "48%" },
	colDate: { width: "21%" },
	colDuration: { width: "10%" },
});

const formatDuration = (milliseconds) => {
	if (!milliseconds) return "-";
	const totalSeconds = Math.floor(milliseconds / 1000);
	const days = Math.floor(totalSeconds / (3600 * 24));
	const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
	const minutes = Math.floor((totalSeconds % 3600) / 60);
	const seconds = totalSeconds % 60;

	const parts = [];
	if (days > 0) parts.push(`${days}d`);
	if (hours > 0) parts.push(`${hours}h`);
	if (minutes > 0) parts.push(`${minutes}m`);
	if (seconds > 0) parts.push(`${seconds}s`);

	return parts.length > 0 ? parts.join(" ") : "0s";
};

const AlertsTable = ({ alerts }) => {
	return (
		alerts?.length > 0 && (
			<View style={styles.tableContainer}>
				<View>
					<Text
						style={{
							fontSize: 14,
							textAlign: "justify",
							color: "#212B36",
							fontFamily: "Times-Bold",
						}}
					>
						Alertas:
					</Text>
				</View>
				<View style={[styles.tableRow, styles.headerRow]} fixed>
					<View style={[styles.tableCellView, styles.colAlert]}>
						<Text style={styles.headerCellText}>Alerta</Text>
					</View>
					<View style={[styles.tableCellView, styles.colDate]}>
						<Text style={styles.headerCellText}>Horário Ocorrência</Text>
					</View>
					<View style={[styles.tableCellView, styles.colDate]}>
						<Text style={styles.headerCellText}>Horário Recuperação</Text>
					</View>
					<View
						style={[styles.tableCellView, styles.colDuration, styles.lastCell]}
					>
						<Text style={styles.headerCellText}>Duração</Text>
					</View>
				</View>

				{/* Dados */}
				{alerts?.map((item, index) => {
					const startDate = dayjs
						.unix(item.initialDate)
						.format("DD/MM/YYYY HH:mm");
					const endDate = dayjs
						.unix(item.recoveryDate)
						.format("DD/MM/YYYY HH:mm");

					const rowStyles = [styles.tableRow];
					if (index % 2 === 0) {
						rowStyles.push(styles.oddRowBackground);
					}

					return (
						<View style={rowStyles} key={index} wrap={false}>
							<View style={[styles.tableCellView, styles.colAlert]}>
								<Text style={styles.tableCellText}>{item.alert}</Text>
							</View>

							<View style={[styles.tableCellView, styles.colDate]}>
								<Text style={styles.tableCellText}>{startDate}</Text>
							</View>

							<View style={[styles.tableCellView, styles.colDate]}>
								<Text style={styles.tableCellText}>{endDate}</Text>
							</View>

							<View
								style={[
									styles.tableCellView,
									styles.colDuration,
									styles.lastCell,
								]}
							>
								<Text style={styles.tableCellText}>
									{formatDuration(item.duration)}
								</Text>
							</View>
						</View>
					);
				})}
			</View>
		)
	);
};

export default AlertsTable;
